<template>
  <div class="pa-3 d-flex flex-column align-center _bg-default">
    <v-card pa-2 class="game">
      <v-toolbar color="indigo" class="mb-3" dense dark
        ><h3>Pinada</h3>
        <v-spacer></v-spacer>
        <v-btn dark @click="HintPinada = true" text>Instruksi Game</v-btn>
      </v-toolbar>
      <v-col cols="12" md="12" v-if="fromRoute">
        <v-btn
          color="indigo"
          dark
          class="ml-3"
          v-if="!isPlayed"
          @click="sendText"
          >Mulai Game</v-btn
        >
      </v-col>
      <v-col cols="12" md="12" class="ml-3">
        <unity
          src="/Pinada/Build/Pinada.json"
          width="900"
          height="500"
          unityLoader="/Pinada/Build/UnityLoader.js"
          ref="myInstance"
        ></unity>
      </v-col>
    </v-card>
    <HintPinada v-bind:HintPinada="HintPinada" @false="closeDialog" />
  </div>
</template>

<script>
import Unity from "vue-unity-webgl";
import HintPinada from "../../components/_base/Game/HintPinada.vue";

export default {
  name: "Game",
  components: {
    Unity,
    HintPinada
  },

  data() {
    return {
      fromRoute: localStorage.getItem("from"),
      isPlayed: false,
      poin: 200,
      id: localStorage.getItem("id"),
      HintPinada: true
    };
  },

  methods: {
    sendText() {
      this.$refs.myInstance.message(
        "Wordhandler",
        "StartGame",
        `${this.id},${this.fromRoute}`
      );
      this.isPlayed = true;
    },
    closeDialog() {
      this.HintPinada = false;
    }
  }
};
</script>

<style scoped>
._bg-default {
  background: #f4f6f9;
}
.game {
  width: max-content;
}
</style>
